<template>
    <div>
        <MainModal 
            :show-modal="showModal" 
            size="sm" 
            :close-btn="false"
        >
            <template #body>
                <div class="modal--section">
                    <div class="upgrade--image">
                        <SvgAssets name="alarm" width="50px" height="50px" class="bg-white" />
                    </div>
                    <div class="upgrade--text">   
                        <div>
                            <!-- <div class="flex align-items-center mb--5"> -->
                            <div class="mb--15">
                                <h2 class="upgrade--title">
                                    {{ title }}
                                </h2>
                                <span
                                    v-if="showPaidPlanBadge" 
                                    class="status__map text--medium tag mt--3 bold badge rounded-pill text--xxs tag--pink text--upper"
                                >
                                    <span 
                                        class="status__circle tag--pink__text text--xxs" 
                                    />
                                    {{ availablePlans.length > 1 ? 'Paid plans' : 'Plus plan' }} only
                                </span>
                            </div>
                            <p class="upgrade--subtitle error">
                                {{ subtitle }}
                            </p>
                            <p class="upgrade--subtitle error mt--10">
                                To get started, go to your <strong>app settings</strong> and upgrade your account plan.
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="w-100 flex justify-content-end align-items-center">
                    <BaseButton 
                        class="mr--5" 
                        variant="outline"
                        label="Cancel" 
                        @submit="$emit('cancel', false)"
                    />

                    <BaseButton 
                        type="submit" 
                        label="Go to settings" 
                        @submit="upgradeAccount"
                    />
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import BaseButton from "../buttons/BaseButton.vue";
import SvgAssets from "../icons/SvgAssets.vue";
import MainModal from "./MainModal.vue";

export default {
    name: "UpgradeAccountAlt",

    components: { MainModal, BaseButton, SvgAssets },

    props: {
        showPaidPlanBadge: {
            type: Boolean,
            default: false,
        },

        availablePlans:  {
            type: Array,
            default: () => [],
        },

        showModal: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        subtitle: {
            type: String,
            default: "",
        },
    },

    emits: ["cancel"],

    methods: {
        upgradeAccount() {
            this.$emit("cancel");
            this.$router.push("/dashboard/settings/payments-and-billings");
        },
    },
};
</script>